import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ResetPasswordModel } from 'src/app/models/Auth.model';
import { LoginService } from 'src/app/services/login/login.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-reset-pass',
  templateUrl: './reset-pass.component.html',
  styleUrls: ['./reset-pass.component.css']
})
export class ResetPassComponent {

  model: ResetPasswordModel = new ResetPasswordModel();
  submitted = false;
  ResetPassForm!: FormGroup;
  isUsernameDisabled: boolean = true;
  containsUsername: boolean = false;
  isCommonPassword: boolean = false;
  containsConsecutiveNumbers: boolean = false;
  containsRepeatingChars: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authservice: LoginService,
    private formBuilder: FormBuilder
  ) { }

  gotologin() {
    this.router.navigate(['login']);
  }
  countDigits: number;
  d1: number;
  d2: number;
  d3: number; 
  c2: boolean; 
  c3: boolean; 
  checkContinuousNumbers:boolean;
  check:number;
  checkD:number;
  ngOnInit(): void {
    this.model.actionType = this.route.snapshot.paramMap.get('actionType') || '';

    // Use queryParams instead of fragment for query parameters
    let token = this.route.snapshot.queryParams['token'] || '';
    let decryptedTokenData = this.decryptToken(token);

    if (decryptedTokenData) {
      this.model.code = decryptedTokenData.Token || '';
      this.model.UserName = decryptedTokenData.Email || '';
    }

    console.log(this.model.actionType);
    console.log(this.model.code);
    console.log(this.model.UserName);

    this.ResetPassForm = this.formBuilder.group({
     
      Password: ['', [Validators.required, Validators.minLength(7)]],
      ConfirmPassword: ['', [Validators.required, Validators.minLength(7)]]
    });

  }


  private decryptToken(encryptedToken: string) {
    // Same decryption key and IV used for encryption
    let key = CryptoJS.enc.Utf8.parse('0123456789abcdef0123456789abcdef');
    let iv = CryptoJS.enc.Utf8.parse('YourIV1234567890');

    // Decrypt the token
    let decrypted = CryptoJS.AES.decrypt(encryptedToken, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    try {
      // Parse the JSON data
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error('Error parsing decrypted token data:', error);
      return null;
    }
  }

  validatePassword(e) {
    let password = e.target.value;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    const isMinLength = password.length >= 7;
    this.containsUsername = password.toLowerCase().includes(this.model.UserName.toLowerCase());
    this.isCommonPassword = password.toLowerCase() === 'password';
   // this.containsConsecutiveNumbers = /\d{3,}/.test(password); // Check for consecutive numbers
   this.countDigits=this.onlyDigits(password);
   console.log(this.containsConsecutiveNumbers);
   this.check=0;
   if(this.countDigits > 2)
   {
      for(let i = password.length - 1; i >= 0; i--)
      {

        const d = password.charCodeAt(i);
        if (d >= 48 && d <= 57) 
        {
          //1A2
          
          
          
          this.check++;
          if(this.check==1)
          {
            this.d1=d;
          }
          if(this.check==2)
          {
            this.d2=d;
          }
          if(this.check==3)
          {
            this.d3=d;
          }
          if(this.check>=3)
            {
              break;
            }
        
        }
        else
        {
          this.check=0;
         if(this.d1 !=null)
         {
          this.d1 == null;
         }
         if(this.d2 !=null)
         {
          this.d2 == null;
         }
         if(this.d3!=null)
         {
          this.d3 == null;
         }
         this.containsConsecutiveNumbers=false;
        }
      }
         if(this.d1==this.d2 && this.d2==this.d3 && this.d1==this.d3)
          {
            this.containsConsecutiveNumbers=true;
          }
          else if((this.d2 - this.d3 ==1 && this.d1-this.d3==2) ||(this.d1 - this.d2 == -1 && this.d1 - this.d3 == -2))
          {
            
              this.containsConsecutiveNumbers=true;
          }
         
          else
          {
            this.containsConsecutiveNumbers=false;
             this.countDigits=0; 
          }
          
   }
   else
   {
    this.containsConsecutiveNumbers=false;
    this.countDigits=0;
   }
    this.containsRepeatingChars = /([a-zA-Z0-9])\1{2,}/.test(password); // Check for repeating characters

    (document.getElementById('lowercaseCheck') as HTMLInputElement).checked = hasLowercase;
    (document.getElementById('uppercaseCheck') as HTMLInputElement).checked = hasUppercase;
    (document.getElementById('numberCheck') as HTMLInputElement).checked = hasNumber;
    (document.getElementById('specialCharCheck') as HTMLInputElement).checked = hasSpecialChar;
    (document.getElementById('minLengthCheck') as HTMLInputElement).checked = isMinLength;
    

  }

  toggleUsernameControl() {
    const control = this.ResetPassForm.get('Username');
    if (control) {
      if (control.disabled) {
        control.enable();
      } else {
        control.disable();
      }
    }
  }

  validateUsername() {
    this.submitted = true; // Trigger validation status
  }

  isPasswordValid(): boolean {
    const password = this.ResetPassForm.value.Password;
    const hasLowercase = /[a-z]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[^a-zA-Z0-9]/.test(password);
    const isMinLength = password.length >= 7;
    const containsUsername = password.toLowerCase().includes(this.model.UserName.toLowerCase());
    const isCommonPassword = password.toLowerCase() === 'password';
    //const containsConsecutiveNumbers = /\d{3,}/.test(password); // Check for consecutive numbers
    
    const containsRepeatingChars = /([a-zA-Z0-9])\1{2,}/.test(password); // Check for repeating characters

    return (hasLowercase && hasUppercase && hasNumber && hasSpecialChar && isMinLength &&
     // !containsConsecutiveNumbers &&
       !containsUsername && !containsRepeatingChars && !isCommonPassword);
  }

  onSubmit() {
    this.submitted = true;

    this.model.password = this.ResetPassForm.value.Password;
    this.model.confirmpassword = this.ResetPassForm.value.ConfirmPassword;


    if (this.model.password !== this.model.confirmpassword) {
      alert(
        `The password and confirmation password do not match.`
      );
    } else {

      if (this.ResetPassForm.valid && this.isPasswordValid()) {
        console.log(this.model);
        this.authservice.resetPassword(this.model).subscribe(
          (data: any) => {
            alert(
              `Your password has been reset.`
            );
            this.router.navigate(['login']);
          },
          customError => {
            alert(
              `An error occurred while resetting your password.
                ${customError.message}`
            );

          }
        )
      }
      else {
        alert(
          `Please validate all fields for password.`
        );
      }
    }
  }

  onlyDigits(s) 
  {
   let count=0;
   let subConsecutive;
   for (let i = s.length-1 ; i >= 0; i--) 
     {
       const d = s.charCodeAt(i);
       if (d >= 48 && d <= 57)
         {
           
             count++;
             //subConsecutive(subConsecutive.length-1)=d;
             if(count==3)
             {
               break;
             }
          
         }
         /*  else
         {
           count=0;
         }  */
         
        
        
      
   
   }
   return count;
 }
}
